import styled from 'styled-components';
import { Colors } from '../../constants/colors';

type LabelProps = {
  required?: boolean;
}

export const Label = styled.label<LabelProps>`
  font-weight: 700;

  ::after {
    content: '*';
    display: ${props => props.required ? 'inline-block': 'none'};
    margin-left: 5px;
    color: ${Colors.primary};
  }
`;
